import logoBlack from '../media/logoBlack.png';
import facebookIcon from '../media/iconFacebook.png';
import twitterIcon from '../media/iconTwitter.png';
import instagramIcon from '../media/iconInstagram.png';

const socialLinks = [
  {
    id: 'facebook',
    label: 'Facebook de Axioma Network',
    url: 'https://www.facebook.com/Axioma.Network/',
    icon: facebookIcon,
  },
  {
    id: 'twitter',
    label: 'Twitter de Axioma Network',
    url: 'https://mobile.twitter.com/axiomanetworkmx',
    icon: twitterIcon,
  },
  {
    id: 'instagram',
    label: 'Instagram de Axioma Network',
    url: 'https://www.instagram.com/Axioma.Network/',
    icon: instagramIcon,
  },
];

/**
 * Pie de página con el logo, las redes sociales y el aviso de copyright.
 *
 * El año se calcula en cada render en vez de estar escrito a mano, para que no
 * se quede atrasado al cambiar de año.
 */
const Footer = () => (
  <footer className="footerBar">
    <div className="footerLogos">
      <div className="footerLogo">
        <img src={logoBlack} alt="Axioma Network" />
      </div>

      <div className="footerSocial">
        {socialLinks.map(({ id, label, url, icon }) => (
          <a
            key={id}
            href={url}
            target="_blank"
            // noopener corta el acceso de la pestaña nueva a window.opener.
            rel="noopener noreferrer"
            aria-label={label}
          >
            <img src={icon} alt="" />
          </a>
        ))}
      </div>
    </div>

    <div className="footerText">
      <p>Copyright © {new Date().getFullYear()} Axioma Network. Todos los derechos reservados.</p>
      <p>Términos y condiciones &nbsp; &nbsp; &nbsp; Aviso de privacidad</p>
    </div>
  </footer>
);

export default Footer;
